import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "users-view" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "add-user-btn" }
const _hoisted_4 = {
  key: 0,
  class: "state-message"
}
const _hoisted_5 = {
  key: 1,
  class: "state-message state-message--error"
}
const _hoisted_6 = {
  key: 2,
  class: "table-container"
}

import { computed, onMounted, ref } from "vue";
import { useUsers } from "@/composables/useUsers";
import DashboardPanel from "@/components/dashboard/DashboardPanel.vue";
import UsersFilterBar from "@/components/user/UsersFilterBar.vue";
import BaseIcon from "@/components/ui/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersView',
  setup(__props) {

const { users, loading, error, fetchUsers } = useUsers();

onMounted(fetchUsers);

const search = ref("");
const statusFilter = ref("all");
const loggedInFilter = ref("all");

const filteredUsers = computed(() => {
  return users.value.filter((u) => {
    const matchesSearch =
      search.value.trim() === "" ||
      u.username.toLowerCase().includes(search.value.toLowerCase()) ||
      u.fullName.toLowerCase().includes(search.value.toLowerCase());

    const matchesStatus =
      statusFilter.value === "all" ||
      (statusFilter.value === "active" && u.isActive) ||
      (statusFilter.value === "inactive" && !u.isActive);

    const matchesLoggedIn =
      loggedInFilter.value === "all" ||
      (loggedInFilter.value === "yes" && u.isLoggedIn) ||
      (loggedInFilter.value === "no" && !u.isLoggedIn);

    return matchesSearch && matchesStatus && matchesLoggedIn;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "page-header-text" }, [
        _createElementVNode("h1", { class: "page-title" }, "Users"),
        _createElementVNode("p", { class: "page-subtitle" }, "Manage and monitor all registered users")
      ], -1)),
      _createElementVNode("button", _hoisted_3, [
        _createVNode(BaseIcon, {
          name: "plus",
          size: 15,
          "stroke-width": 2.5
        }),
        _cache[3] || (_cache[3] = _createElementVNode("span", null, "Add User", -1))
      ])
    ]),
    _createVNode(UsersFilterBar, {
      search: search.value,
      "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
      status: statusFilter.value,
      "onUpdate:status": _cache[1] || (_cache[1] = ($event: any) => ((statusFilter).value = $event)),
      "logged-in": loggedInFilter.value,
      "onUpdate:loggedIn": _cache[2] || (_cache[2] = ($event: any) => ((loggedInFilter).value = $event)),
      total: _unref(users).length,
      filtered: filteredUsers.value.length
    }, null, 8, ["search", "status", "logged-in", "total", "filtered"]),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading..."))
      : (_unref(error))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(error)), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(DashboardPanel, {
              title: "All Users",
              dot: "cyan",
              users: filteredUsers.value,
              columns: [
          'id',
          'username',
          'fullName',
          'createdAt',
          'isActive',
          'isLoggedIn',
          'action',
        ]
            }, null, 8, ["users"])
          ]))
  ]))
}
}

})